import Icon from '@/common/components/Icon';
import { ReasonCell, ReasonItem } from '../../../InvoiceConfig.styled';

export const getRaws = (invoiceConfigs, setInvoiceConfig) =>
	invoiceConfigs.map((config, i) => (
		<tr key={config._id}>
			<td>{i + 1}</td>
			<td>{config.name}</td>
			<td>{config.buyer_note}</td>
			<ReasonCell>
				{config.correction_reasons?.map((cr, idx) => (
					<ReasonItem key={idx}>{cr}</ReasonItem>
				))}
			</ReasonCell>
			<td>{config.description}</td>
			<td>
				<Icon onClick={() => setInvoiceConfig(config)} name='edit' />
			</td>
		</tr>
	));
